module.exports = __webpack_public_path__ + "assets/img/34-s.a236418.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/photo/objects/34-s.jpg
// module id = TcmZ
// module chunks = 0